import React, { useState } from 'react';
import Select, { components } from 'react-select';

const InputOption = ({
	getStyles,
	isDisabled,
	isFocused,
	isSelected,
	children,
	innerProps,
	isMulti,
	...rest
}) => {
	const [isActive, setIsActive] = useState(false);
	const onMouseDown = () => setIsActive(true);
	const onMouseUp = () => setIsActive(false);
	const onMouseLeave = () => setIsActive(false);
	// styles
	let bg = 'transparent';
	if (isFocused) bg = '#eee';
	if (isActive) bg = '#B2D4FF';

	const style = {
		alignItems: 'center',
		backgroundColor: bg,
		color: 'inherit',
		display: 'flex '
	};

	// prop assignment
	const props = {
		...innerProps,
		onMouseDown,
		onMouseUp,
		onMouseLeave,
		style
	};
	return (
		<components.Option
			{...rest}
			isDisabled={isDisabled}
			isFocused={isFocused}
			isSelected={isSelected}
			getStyles={getStyles}
			innerProps={props}
		>
			{isMulti ? (
				<>
					<input type="checkbox" checked={isSelected} disabled={rest?.data?.isDisabled} />
					&nbsp;{children}
				</>
			) : (
				children
			)}
		</components.Option>
	);
};

const CustomSelectableDropdown = ({
	allOptions,
	setSelectedOptions,
	selectedOptions = [],
	isMulti = true,
	isDisabled,
	placeholder = '',
	onInputChange
}) => {
	return (
		<div>
			<Select
				placeholder={placeholder}
				value={selectedOptions}
				isMulti={isMulti}
				isDisabled={isDisabled}
				closeMenuOnSelect={!isMulti}
				hideSelectedOptions={false}
				onChange={(options) => {
					if (Array.isArray(options)) {
						setSelectedOptions(options);
					} else {
						setSelectedOptions([options]);
					}
				}}
				options={allOptions}
				components={{
					Option: InputOption
				}}
				onInputChange={onInputChange}
			/>
		</div>
	);
};

export default CustomSelectableDropdown;
